import { NotificationsService } from '@/api/models/notifications'

export type NotificationsListPayload = {
  projectId: string
  typeAlias?: string[]
  onlyUnread?: boolean
}

export type ReadNotificationsPayload = {
  projectId: string
  typeAlias?: string[]
}

export enum NotificationType {
  Service = 'service',
  Basic = 'basic',
  Requests = 'requests',
  Passes = 'passes',
  Invoices = 'invoices',
  InvoicesReminder = 'invoicesReminder',
  InvoicesDebt = 'invoicesDebt',
  Comments = 'comments',
  News = 'news',
  Proposals = 'proposals',
  Counters = 'counters'
}

export type NotificationApiType = {
  id: string
  contentId: string | null
  contentParentId: string | null
  createdAt: string
  title: string
  description: string
  typeAlias: NotificationType
  deepLink: string | null
  isRead: boolean
}

export type RequestReturnType = Awaited<
  ReturnType<typeof NotificationsService.getNotificationsList>
>

export type ListRequestReturnType = Awaited<
  ReturnType<typeof NotificationsService.getNotificationsList>
>
